import { createRegisteredContext } from 'react-singleton-context';
/**
 * @ignore - internal component.
 */
const ButtonGroupContext = createRegisteredContext('ButtonGroupContext', {});
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'LHButtonGroupContext';
}
export default ButtonGroupContext;